/* eslint-disable jira/naming/disallow-filenames */
// eslint-disable-next-line jira/filename-case
import React, { useEffect } from 'react';
import { useManageViewPermissions } from '@jira/polaris__component-permissions-store/src/useCanEditIssues.tsx';
import { useContainerTypePermissions, useContainerId } from '../context.tsx';

const JpdNavViewsPermissionsLoader = ({ children }: { children: React.ReactNode }) => {
	const containerId = useContainerId();
	const { loadViewPermissionsForCurrentUser } = useManageViewPermissions(containerId);

	useEffect(() => {
		loadViewPermissionsForCurrentUser(containerId);
	}, [loadViewPermissionsForCurrentUser, containerId]);

	return children;
};

export const JpdNavViewsPermissions = ({
	children,
}: {
	children: React.ReactNode;
}):
	| string
	| number
	| boolean
	| Iterable<React.ReactNode>
	| React.JSX.Element
	| null
	| undefined => {
	const containerTypePermissions = useContainerTypePermissions();

	if (containerTypePermissions === 'view') {
		// For `view` based permissions we trigger loading
		// based on user interaction like opening a view menu
		return children;
	}

	return <JpdNavViewsPermissionsLoader>{children}</JpdNavViewsPermissionsLoader>;
};
